import { Link, useLocation } from 'react-router-dom';
import { SignIn as ClerkSignIn, ClerkProvider } from '@clerk/clerk-react';

const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

export default function SignIn() {
  const location = useLocation();
  
  // Get the intended destination from location state, or default to /dashboard
  const from = location.state?.from?.pathname || '/dashboard';
  
  return (
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-amber-50 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <Link to="/" className="inline-flex items-center gap-3 mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#f97316" viewBox="0 0 256 256">
                <path d="M169.57,72.59A80,80,0,0,0,16,104v64a16,16,0,0,0,16,16H86.67A80.15,80.15,0,0,0,160,232h64a16,16,0,0,0,16-16V152A80,80,0,0,0,169.57,72.59ZM32,104a64,64,0,1,1,64,64H32ZM224,216H160a64.14,64.14,0,0,1-55.68-32.43A79.93,79.93,0,0,0,174.7,89.71,64,64,0,0,1,224,152Z"></path>
              </svg>
              <span className="text-2xl font-bold text-gray-900">DAZZA</span>
            </Link>
          </div>

          <div className="flex justify-center" data-testid="clerk-signin">
            <ClerkSignIn 
              routing="path" 
              path="/sign-in" 
              signUpUrl="/sign-up"
              fallbackRedirectUrl={from}
              appearance={{
                elements: {
                  rootBox: 'w-full',
                  card: 'shadow-xl border border-gray-100',
                  headerTitle: 'text-gray-900',
                  headerSubtitle: 'text-gray-600',
                  socialButtonsBlockButton: 'border-gray-200 hover:bg-gray-50',
                  formButtonPrimary: 'bg-orange-500 hover:bg-orange-600',
                  footerActionLink: 'text-orange-600 hover:text-orange-700',
                }
              }}
            />
          </div>

          <p className="text-center mt-6">
            <Link to="/" className="text-sm text-gray-500 hover:text-gray-700">
              ← Back to home
            </Link>
          </p>
        </div>
      </div>
    </ClerkProvider>
  );
}
